// src/Callback.js
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';

const Callback = () => {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (auth.isAuthenticated) {
      navigate("/dashboard"); // Redirect to secure page
    } else if (auth.error) {
      console.error(auth.error);
    }
  }, [auth.isAuthenticated, auth.error, navigate]);

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1>Logging you in...</h1>
    </div>
  );
};

export default Callback;
